import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';

const ConfirmModal = ({ 
  open, 
  message, 
  confirmText = '확인', 
  cancelText = '취소', 
  onConfirm, 
  onCancel,
  warningMessage,
}) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        bgcolor: 'rgba(0,0,0,0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Paper
        elevation={3}
        sx={{
          width: 322,
          maxWidth: '90%',
          p: 4,
          minHeight: 220,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1,
          }}
        >
          <Typography variant="body1">
            {message}
          </Typography>
        </Box>
        
        {warningMessage && (
          <Box sx={{ mb: 2, textAlign: 'center' }}>
            <Typography
              variant="body2"
              sx={{
                color: '#d32f2f',
                fontWeight: 600,
                fontSize: 13,
                lineHeight: 1.5,
              }}
            >
              {warningMessage}
            </Typography>
          </Box>
        )}
        
        <Box sx={{ display: 'flex', gap: 1, mt: 'auto' }}>
          {onCancel && (
            <Button
              variant="outlined"
              fullWidth
              sx={{
                height: 38,
                fontWeight: 600,
                borderColor: '#d0d0d0',
                color: '#333',
                '&:hover': {
                  borderColor: '#b0b0b0',
                  bgcolor: '#f8f8f8',
                },
              }}
              onClick={onCancel}
            >
              {cancelText}
            </Button>
          )}
          <Button
            variant="contained"
            fullWidth
            sx={{
              height: 38,
              bgcolor: '#0d47a1',
              fontWeight: 600,
              '&:hover': {
                bgcolor: '#0b3a81',
              },
            }}
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default ConfirmModal;


